import {
  Box,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from '@mui/material'

import { DateTimePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'

const DateRangeSelector = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  userTimezone,
  userDateFormat,
  isMobile,
}) => {
  const theme = useTheme()

  const isActiveButton = (months) => {
    if (months === 0) {
      return !startDate && !endDate
    } else {
      return (
        startDate &&
        endDate &&
        startDate.isSame(dayjs().subtract(months, 'month'), 'day') &&
        endDate.isSame(dayjs().endOf('day'), 'day')
      )
    }
  }

  const setLastDays = (months) => {
    if (months === 0) {
      resetDates()
    } else {
      setStartDate(dayjs().subtract(months, 'month'))
      setEndDate(dayjs().endOf('day'))
    }
  }

  const resetDates = () => {
    setStartDate(null)
    setEndDate(null)
  }

  const formatMap = {
    iso: 'YYYY-MM-DD',
    eur: 'DD.MM.YYYY',
    usa: 'MM/DD/YYYY',
  }

  const dateFormat = formatMap[userDateFormat] || 'YYYY-MM-DD'

  return (
    <Stack gap={2}>
      <Typography variant={isMobile ? 'body2' : 'body1'}>
        Show experiments running between:
      </Typography>

      <Stack
        direction={isMobile ? 'column' : 'row'}
        gap={2}
        alignItems={'center'}
        flexWrap={'wrap'}
      >
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          <ToggleButtonGroup>
            {[0, 1, 3, 12].map((month) => (
              <ToggleButton
                key={month}
                variant="outlined"
                size="small"
                selected={isActiveButton(month)}
                onClick={() => setLastDays(month)}
              >
                {month === 0 ? 'All' : `${month} M`}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>

        <Stack direction={'row'} gap={2} flexWrap={'wrap'}>
          <DateTimePicker
            label="Start Date"
            value={startDate}
            onChange={setStartDate}
            format={dateFormat}
            timezone={userTimezone}
            views={['year', 'month', 'day']}
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: false,
              },
            }}
          />
          <DateTimePicker
            label="End Date"
            value={endDate}
            onChange={setEndDate}
            format={dateFormat}
            timezone={userTimezone}
            views={['year', 'month', 'day']}
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: false,
              },
            }}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default DateRangeSelector
